import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const TextAreaFieldStyled = styled.div`
  width: 100%;
  position: relative;
  margin-top: 43px;
  
  textarea {
    width: 100%;
    padding: 20px 30px;
    resize: none;
    font: inherit;
    border: 1px solid ${props => props.error ? '#CD2028' : '#C5B3AF'};
  }
  
  textarea:focus {
    border-color: #02A0DA;
  }

  .transition, textarea:focus + #custom-label {
    top: -25px;
    left: 10px;
    font-size: 10.5px;
  }
  
  .transition {
    color: ${props => props.error ? '#CD2028' : '#BCAAA3'};
  }
  
  textarea:focus + #custom-label {
    color: ${props => props.error ? '#CD2028' : '#04A2DC'};
  }
`;

const LabelStyled = styled.div`
    position: absolute;
    left: 13px;
    top: 13px;
    font-size: 14px;
    color: #bcaaa3;
    transition: all 0.2s cubic-bezier(0.65, 0.05, 0.36, 1);
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 1px;
    
    span:first-child {
        font-weight: normal;
        text-transform: none;
    }
`;

const CharactersLabelStyled = styled.div`
  display: ${props => props.show ? 'inherit' : 'none'};
  
  font-size: 12px;
  color: #3E2723;
  letter-spacing: 0;
  line-height: 20px;
  padding: 4px 0 0 13px;
`;

const ErrorSpanStyled = styled.span`
    display: ${props => props.show ? 'inline' : 'none'};
    text-transform: capitalize;
    color: #CD2028;
    font-weight: 400;
`;

class TextAreaField extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: props.value,
            error: props.error
        };
    }

    componentWillReceiveProps(nextProps) {
        const newState = {};
        if (nextProps.value !== this.state.value) {
            newState.value = nextProps.value;
        }
        if (nextProps.error !== this.state.error) {
            newState.error = nextProps.error;
        }
        this.setState(newState);
    }

    handleChange = (e) => {
        const value = e.target.value;
        this.setState({ value, error: '' }, this.props.handleChange({ comments: value }));
    };

    render() {
        const transition = (!!this.state.value || !!this.state.error) ? 'transition' : '';

        const errorState = !!this.state.error;

        return (
            <TextAreaFieldStyled error={errorState}>
                <textarea id={this.props.id}
                    rows="6" maxLength='500'
                    placeholder={this.props.placeholder}
                    value={this.state.value}
                    onBlur={this.props.validate}
                    onChange={this.handleChange} />
                <LabelStyled id='custom-label' className={transition}>
                    {`${this.props.label} `}
                    <ErrorSpanStyled show={errorState}>
                        {this.props.getLocalizedText('Required', 'required')}
                    </ErrorSpanStyled>
                </LabelStyled>
                <CharactersLabelStyled show={this.state.value.length > 0}>
                    {`${500 - this.state.value.length} ${this.props.getLocalizedText('CharactersRemaining', 'characters remaining')}`}
                </CharactersLabelStyled>
            </TextAreaFieldStyled>
        );
    }

}

TextAreaField.propTypes = {
    id: PropTypes.string,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    handleChange: PropTypes.func,
    validate: PropTypes.func,
    getLocalizedText: PropTypes.func.isRequired,
    error: PropTypes.string,
    locale: PropTypes.shape({
        country: PropTypes.string,
        language: PropTypes.string,
        localeCode: PropTypes.string
    })
};

TextAreaField.defaultProps = {
    id: '',
    placeholder: '',
    label: '',
    value: '',
    handleChange: () => {},
    validate: () => {},
    getLocalizedText: (key, defaultValue) => defaultValue,
    error: '',
    locale: {
        country: 'US',
        language: 'en',
        localeCode: 'en_US'
    }
};

export default TextAreaField;



// WEBPACK FOOTER //
// ./src/components/TextAreaField/index.js